import { render, staticRenderFns } from "./AppFrame.vue?vue&type=template&id=24ed47fc&scoped=true&"
import script from "./AppFrame.vue?vue&type=script&lang=ts&"
export * from "./AppFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed47fc",
  null
  
)

export default component.exports